import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './../firebase-config';
import SingleCourse from '../components/Courses/SingleCourse';
import Spinner from '../components/Spinner';

export default function Courses() {
  const [coursesData, setCoursesData] = useState([]);
  const coursesDocRef = collection(db, 'courses-data');

  const getCoursesData = async () => {
    const querySnapshot = await getDocs(coursesDocRef);
    let d = [];
    querySnapshot.forEach((doc) => {
      return d.push({
        id: doc.id,
        data: doc.data(),
      });
    });
    setCoursesData(d);
  };

  useEffect(() => {
    document.title = 'Dr. Nithin M | Courses';
    getCoursesData();
  }, []);
  return (
    <section class='blog-section'>
      {/* <div className='container'> */}
      <div>
        <h2 class='section-title'>Current Courses</h2>
        {coursesData.length > 0 ? (
          <div class='row'>
            {coursesData.length > 0 &&
              coursesData.map((course) => {
                if (course['data']['status'])
                  return (
                    <SingleCourse
                      link={course['id']}
                      desc={course['data']['desc']}
                      title={course['data']['title']}
                      imageSrc={course['data']['image']}
                    />
                  );
              })}
          </div>
        ) : (
          <Spinner />
        )}
      </div>
      <hr style={{ 'border-width': '3px' }} />
      <div>
        <h2 class='section-title' style={{ marginTop: '20px' }}>
          Previous Courses
        </h2>
        {coursesData.length > 0 ? (
          <div class='row'>
            {coursesData.length > 0 &&
              coursesData.map((course) => {
                if (!course['data']['status'])
                  return (
                    <SingleCourse
                      link={course['id']}
                      desc={course['data']['desc']}
                      title={course['data']['title']}
                      imageSrc={course['data']['image']}
                    />
                  );
              })}
          </div>
        ) : (
          <Spinner />
        )}
      </div>
      {/* </div> */}
    </section>
  );
}
